<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { RichtextResolver, type ISbRichtext } from 'storyblok-js-client'

const props = defineProps({
  doc: {
    type: Object as PropType<ISbRichtext>,
    required: true,
  },
})

const resolver = new RichtextResolver()

const content = computed(() => resolver.render(props.doc))
</script>

<template>
  <div v-dompurify-html="content" />
</template>
